import { Box, IconButton } from '@mui/material';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { useTranslation } from 'react-i18next';
import TooltipCC from '../TooltipCC';
import './DateRangePicker.css';
import IconCalendar from 'assets/manager-meetings/IconCalendar';
import { useState } from 'react';

function handleFocusCalendar(inputId) {
    if (document.querySelector(`#${inputId}`)) document.querySelector(`#${inputId}`).focus()
}

/**
 * Component chọn ngày
 * @param {*} param0 
 * @returns 
 */
const SingleDateClearable = ({ timePicker, setTimePicker, dateRangePickerProps, initialSettingsProps, inputId = "input-daterange", formatTime = "DD/MM/YYYY", inputProps, containerClass = "daterange-container", positionTooltip = "bottom", ...props }) => {

    const { t } = useTranslation()
    const [focusInput, setFocusInput] = useState('')

    const handleFocusInput = () => {
        setFocusInput("daterange-container-focus")
    }

    const handleEvent = (event, picker) => {
        if (event.type === "hide") {
            picker.element.val(null);
            setTimePicker({
                date: null
            })
        } else {
            picker.element.val(
                picker.startDate.format('MM/DD/YYYY')
            );
            setTimePicker({
                date: moment(picker.startDate).startOf('day'),
            })
        }
    }

    return (
        <Box component={'div'} className={`daterange-container ${focusInput} ${containerClass}`} {...props}>
            <DateRangePicker
                // {...dateRangePickerProps}
                initialSettings={{

                    ...initialSettingsProps,
                    startDate: timePicker.startDate,
                    endDate: timePicker.endDate,
                    autoApply: true,
                    showDropdowns: true,
                    autoUpdateInput: false,
                    locale: {
                        format: formatTime,
                        cancelLabel: t('filter.dateRange.cancel'),
                        applyLabel: t('filter.dateRange.apply'),
                        daysOfWeek: [
                            t('dateRangePicker.Su'),
                            t('dateRangePicker.Mo'),
                            t('dateRangePicker.Tu'),
                            t('dateRangePicker.We'),
                            t('dateRangePicker.Th'),
                            t('dateRangePicker.Fr'),
                            t('dateRangePicker.Sa'),
                        ],
                        monthNames: [
                            t('dateRangePicker.January'),
                            t('dateRangePicker.February'),
                            t('dateRangePicker.March'),
                            t('dateRangePicker.April'),
                            t('dateRangePicker.May'),
                            t('dateRangePicker.June'),
                            t('dateRangePicker.July'),
                            t('dateRangePicker.August'),
                            t('dateRangePicker.September'),
                            t('dateRangePicker.October'),
                            t('dateRangePicker.November'),
                            t('dateRangePicker.December'),
                        ],
                    },
                }}
                onApply={handleEvent}
                onHide={(_, picker) => { setFocusInput(''); handleEvent(_, picker) }}
            >
                <input sx={{ minWidth: '270px' }} id={inputId} type='text' className='input-daterange form-control col input-form-focus' {...inputProps} onClick={handleFocusInput} placeholder='DD/MM/YYYY' />
            </DateRangePicker>
            <TooltipCC title={t('pickDateRange')} placement={positionTooltip}>
                <IconButton onClick={() => handleFocusCalendar(inputId)} className='icon-calendar' size='small'>
                    <IconCalendar />
                </IconButton>
            </TooltipCC>
        </Box>
    )
}

export default SingleDateClearable